<template>
  <div class="main-wrapper">
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <!-- Page Content -->
      <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
          <div class="row align-items-center">
            <div class="col">
              <h3 class="page-title">Quản lý người dùng</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li class="breadcrumb-item active">Người dùng</li>
              </ul>
            </div>
            <div class="col-auto float-right ml-auto">
              <button class="btn add-btn" @click="openAdd">
                <i class="fa fa-plus"></i> Thêm người dùng
              </button>
            </div>
          </div>
          <!-- search + filter -->
          <div class="row mt-2">
            <div class="col-md-4">
              <input
                v-model="keyword"
                @keyup.enter="loadUsers(0)"
                class="form-control"
                placeholder="Search user name / email / username và bấm Enter"
              />
            </div>
            <div class="col-md-4">
              <select
                class="form-control"
                v-model="filterPhongBanId"
                @change="loadUsers(0)"
              >
                <option :value="null">-- Tất cả phòng ban --</option>
                <option
                  v-for="pb in phongBanOptions"
                  :key="pb.idPhongBan"
                  :value="pb.idPhongBan"
                >
                  {{ pb.tenPhongBan }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-striped custom-table">
                <thead>
                  <tr>
                    <th>Tên</th>
                    <th>Tên đăng nhập</th>
                    <th>Email</th>
                    <th>Phòng ban</th>
                    <th>Chức vụ</th>
                    <th>Trạng thái</th>
                    <th class="text-right">Hành động</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="u in users" :key="u.idNguoiDung">
                    <td>
                      <h2 class="table-avatar">
                        <a href="javascript:void(0)" class="avatar">
                          <img
                            :src="u.avatarUrl || defaultAvatar"
                            :alt="u.hoTen || u.tenDangNhap"
                          />
                        </a>
                        <a href="javascript:void(0)">{{
                          u.hoTen || u.tenDangNhap
                        }}</a>
                      </h2>
                    </td>
                    <td>{{ u.tenDangNhap }}</td>
                    <td>{{ u.email }}</td>
                    <td>{{ u.phongBan || "-" }}</td>
                    <td>
                      <span
                        class="badge"
                        :class="
                          u.chucVu
                            ? 'bg-inverse-success'
                            : 'bg-inverse-secondary'
                        "
                      >
                        {{ u.chucVu || "-" }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="badge"
                        :class="
                          u.trangThai === 1
                            ? 'bg-inverse-success'
                            : 'bg-inverse-danger'
                        "
                      >
                        {{ u.trangThai === 1 ? "Active" : "Inactive" }}
                      </span>
                    </td>
                    <td class="text-right">
                      <div class="dropdown dropdown-action">
                        <a
                          href="#"
                          class="action-icon dropdown-toggle"
                          data-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i class="material-icons">more_vert</i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a
                            class="dropdown-item"
                            href="#"
                            @click.prevent="openEdit(u)"
                          >
                            <i class="fa fa-pencil m-r-5"></i> Chỉnh sửa
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click.prevent="confirmDelete(u)"
                          >
                            <i class="fa fa-trash-o m-r-5"></i> Xóa
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="users.length === 0">
                    <td colspan="7" class="text-center text-muted">No data</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div class="d-flex justify-content-between align-items-center">
              <div>Trang {{ page + 1 }} / {{ totalPages || 1 }}</div>
              <div>
                <button
                  class="btn btn-sm btn-outline-secondary mr-2"
                  :disabled="page === 0"
                  @click="loadUsers(page - 1)"
                >
                  Trước
                </button>
                <button
                  class="btn btn-sm btn-outline-secondary"
                  :disabled="page + 1 >= totalPages"
                  @click="loadUsers(page + 1)"
                >
                  Tiếp theo
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->

      <!-- Add User Modal -->
      <div
        v-if="showAdd"
        class="modal custom-modal fade show d-block"
        role="dialog"
        style="background: rgba(0, 0, 0, 0.4)"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Thêm người dùng</h5>
              <button type="button" class="close" @click="closeAdd">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitAdd">
                <div class="row">
                  <!-- Avatar upload + preview -->
                  <div class="col-sm-12 mb-3">
                    <div class="d-flex align-items-center">
                      <img
                        :src="avatarPreviewAdd || defaultAvatar"
                        class="avatar-lg mr-3"
                        alt="preview"
                      />
                      <div>
                        <input
                          type="file"
                          accept="image/*"
                          @change="onAddAvatarSelect"
                        />
                        <small class="text-muted d-block">JPG/PNG ≤ 5MB</small>
                        <div v-if="uploadingAddAvatar" class="text-muted">
                          Đang tải lên...
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Họ <span class="text-danger">*</span></label>
                      <input
                        class="form-control"
                        v-model="formAdd.firstName"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Tên</label>
                      <input class="form-control" v-model="formAdd.lastName" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Username <span class="text-danger">*</span></label>
                      <input
                        class="form-control"
                        v-model="formAdd.tenDangNhap"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Email <span class="text-danger">*</span></label>
                      <input
                        class="form-control"
                        type="email"
                        v-model="formAdd.email"
                        required
                      />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Mật khẩu <span class="text-danger">*</span></label>
                      <input
                        class="form-control"
                        type="password"
                        v-model="formAdd.matKhau"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Nhập lại mật khẩu</label>
                      <input
                        class="form-control"
                        type="password"
                        v-model="formAdd.confirmPassword"
                      />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Số điện thoại</label>
                      <input
                        class="form-control"
                        v-model="formAdd.soDienThoai"
                      />
                    </div>
                  </div>

                  <!-- ===== Trường MỚI ===== -->
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Ngày sinh</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="formAdd.ngaySinh"
                      />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Giới tính</label>
                      <select
                        class="form-control"
                        v-model.number="formAdd.gioiTinh"
                      >
                        <option :value="null">—</option>
                        <option :value="1">Nam</option>
                        <option :value="2">Nữ</option>
                        <option :value="3">Khác</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Tình trạng hôn nhân</label>
                      <select
                        class="form-control"
                        v-model.number="formAdd.tinhTrangHonNhan"
                      >
                        <option :value="null">—</option>
                        <option :value="1">Độc thân</option>
                        <option :value="2">Đã kết hôn</option>
                        <option :value="3">Ly hôn</option>
                        <option :value="4">Góa</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>CCCD (9–12 chữ số)</label>
                      <input
                        class="form-control"
                        v-model="formAdd.cccd"
                        placeholder="012345678901"
                      />
                    </div>
                  </div>

                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Địa chỉ</label>
                      <textarea
                        rows="2"
                        class="form-control"
                        v-model="formAdd.diaChi"
                      ></textarea>
                    </div>
                  </div>
                  <!-- ======================= -->

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Chức vụ</label>
                      <select
                        class="form-control"
                        v-model="formAdd.idChucVu"
                        required
                      >
                        <option
                          v-for="cv in chucVuOptions"
                          :key="cv.idChucVu"
                          :value="cv.idChucVu"
                        >
                          {{ cv.tenChucVu }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Phòng ban</label>
                      <select
                        class="form-control"
                        v-model="formAdd.idPhongBan"
                        required
                      >
                        <option
                          v-for="pb in phongBanOptions"
                          :key="pb.idPhongBan"
                          :value="pb.idPhongBan"
                        >
                          {{ pb.tenPhongBan }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-6 d-flex align-items-center">
                    <div class="form-group mb-0">
                      <label class="mr-2">Kích hoạt</label>
                      <input type="checkbox" v-model="formAdd.active" />
                    </div>
                  </div>
                </div>

                <!-- Permission Matrix -->
                <div
                  class="table-responsive m-t-15"
                  v-if="actions.length && chucNangList.length"
                >
                  <table class="table table-striped custom-table">
                    <thead>
                      <tr>
                        <th>Phân quyền chức năng</th>
                        <th
                          class="text-center"
                          v-for="act in actions"
                          :key="act.maHanhDong"
                        >
                          {{ act.maHanhDong }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="cn in chucNangList" :key="cn.idChucNang">
                        <td>{{ cn.tenChucNang }}</td>
                        <td
                          class="text-center"
                          v-for="act in actions"
                          :key="act.maHanhDong"
                        >
                          <input
                            type="checkbox"
                            v-model="matrixAdd[cn.tenChucNang][act.maHanhDong]"
                            :disabled="
                              !isAllowed(cn.tenChucNang, act.maHanhDong)
                            "
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="submit-section">
                  <button
                    class="btn btn-primary submit-btn"
                    :disabled="savingAdd || uploadingAddAvatar"
                  >
                    <span v-if="!savingAdd">Gửi</span>
                    <span v-else>Đang lưu...</span>
                  </button>
                  <button
                    type="button"
                    class="btn btn-link ml-2"
                    @click="closeAdd"
                  >
                    Hủy
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- /Add User Modal -->

      <!-- Edit User Modal -->
      <div
        v-if="showEdit"
        class="modal custom-modal fade show d-block"
        role="dialog"
        style="background: rgba(0, 0, 0, 0.4)"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Chỉnh sửa người dùng</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitEdit">
                <div class="row">
                  <!-- Avatar upload + preview -->
                  <div class="col-sm-12 mb-3">
                    <div class="d-flex align-items-center">
                      <img
                        :src="avatarPreviewEdit || defaultAvatar"
                        class="avatar-lg mr-3"
                        alt="preview"
                      />
                      <div>
                        <input
                          type="file"
                          accept="image/*"
                          @change="onEditAvatarSelect"
                        />
                        <small class="text-muted d-block">JPG/PNG ≤ 5MB</small>
                        <div v-if="uploadingEditAvatar" class="text-muted">
                          Đang tải lên...
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Họ và tên</label>
                      <input class="form-control" v-model="formEdit.hoTen" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Username</label>
                      <input
                        class="form-control"
                        v-model="formEdit.tenDangNhap"
                      />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Email</label>
                      <input
                        class="form-control"
                        type="email"
                        v-model="formEdit.email"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Số điện thoại</label>
                      <input
                        class="form-control"
                        v-model="formEdit.soDienThoai"
                      />
                    </div>
                  </div>

                  <!-- ===== Trường MỚI ===== -->
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Ngày sinh</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="formEdit.ngaySinh"
                      />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Giới tính</label>
                      <select
                        class="form-control"
                        v-model.number="formEdit.gioiTinh"
                      >
                        <option :value="null">—</option>
                        <option :value="1">Nam</option>
                        <option :value="2">Nữ</option>
                        <option :value="3">Khác</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Tình trạng hôn nhân</label>
                      <select
                        class="form-control"
                        v-model.number="formEdit.tinhTrangHonNhan"
                      >
                        <option :value="null">—</option>
                        <option :value="1">Độc thân</option>
                        <option :value="2">Đã kết hôn</option>
                        <option :value="3">Ly hôn</option>
                        <option :value="4">Góa</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>CCCD (9–12 chữ số)</label>
                      <input
                        class="form-control"
                        v-model="formEdit.cccd"
                        placeholder="012345678901"
                      />
                    </div>
                  </div>

                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Địa chỉ</label>
                      <textarea
                        rows="2"
                        class="form-control"
                        v-model="formEdit.diaChi"
                      ></textarea>
                    </div>
                  </div>
                  <!-- ======================= -->

                  <!-- đổi mật khẩu (tùy chọn) -->
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Mật khẩu mới</label>
                      <input
                        class="form-control"
                        type="password"
                        v-model="formEdit.matKhau"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Xác nhận mật khẩu mới</label>
                      <input
                        class="form-control"
                        type="password"
                        v-model="formEdit.confirmMatKhau"
                      />
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Chức vụ</label>
                      <select class="form-control" v-model="formEdit.idChucVu">
                        <option
                          v-for="cv in chucVuOptions"
                          :key="cv.idChucVu"
                          :value="cv.idChucVu"
                        >
                          {{ cv.tenChucVu }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Phòng ban</label>
                      <select
                        class="form-control"
                        v-model="formEdit.idPhongBan"
                      >
                        <option
                          v-for="pb in phongBanOptions"
                          :key="pb.idPhongBan"
                          :value="pb.idPhongBan"
                        >
                          {{ pb.tenPhongBan }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-6 d-flex align-items-center">
                    <div class="form-group mb-0">
                      <label class="mr-2">Kích hoạt</label>
                      <input type="checkbox" v-model="formEdit.active" />
                    </div>
                  </div>
                </div>

                <!-- Permission Matrix -->
                <div
                  class="table-responsive m-t-15"
                  v-if="actions.length && Object.keys(matrixEdit).length"
                >
                  <table class="table table-striped custom-table">
                    <thead>
                      <tr>
                        <th>Phân quyền chức năng</th>
                        <th
                          class="text-center"
                          v-for="act in actions"
                          :key="act.maHanhDong"
                        >
                          {{ act.maHanhDong }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(actionsMap, moduleName) in matrixEdit"
                        :key="moduleName"
                      >
                        <td>{{ moduleName }}</td>
                        <td
                          class="text-center"
                          v-for="act in actions"
                          :key="act.maHanhDong"
                        >
                          <input
                            type="checkbox"
                            v-model="matrixEdit[moduleName][act.maHanhDong]"
                            :disabled="!isAllowed(moduleName, act.maHanhDong)"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="submit-section">
                  <button
                    class="btn btn-primary submit-btn"
                    :disabled="savingEdit || uploadingEditAvatar"
                  >
                    <span v-if="!savingEdit">Lưu</span>
                    <span v-else>Đang lưu...</span>
                  </button>
                  <button
                    type="button"
                    class="btn btn-link ml-2"
                    @click="closeEdit"
                  >
                    Hủy
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- /Edit User Modal -->

      <!-- Delete User Modal -->
      <div
        v-if="showDelete"
        class="modal custom-modal fade show d-block"
        role="dialog"
        style="background: rgba(0, 0, 0, 0.4)"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Xóa người dùng</h3>
                <p>
                  Bạn có chắc chắn muốn xóa
                  <strong>{{ toDelete?.hoTen || toDelete?.tenDangNhap }}</strong
                  >?
                </p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary continue-btn"
                      @click="doDelete"
                      >Xóa</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary cancel-btn"
                      @click="showDelete = false"
                      >Hủy</a
                    >
                  </div>
                </div>
              </div>
              <div v-if="deleting" class="text-center text-muted mt-2">
                Đang xóa...
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Delete User Modal -->
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import axiosLib from "axios";

/** ====== Axios instance (auto attach Bearer token) ====== */
const api = axiosLib.create({ baseURL: process.env.VUE_APP_BASEURL });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (!(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }
  return config;
});

/** ====== State ====== */
const defaultAvatar = "assets/img/profiles/logominhtien.png";

const users = ref([]);
const page = ref(0);
const size = ref(10);
const totalPages = ref(0);
const keyword = ref("");
const filterPhongBanId = ref(null);

const chucVuOptions = ref([]);
const phongBanOptions = ref([]);
const actions = ref([]);
const chucNangList = ref([]);
const allowedPairs = ref(new Set());
function isAllowed(moduleName, actionCode) {
  return allowedPairs.value.has(`${moduleName}__${actionCode}`);
}

/** ====== Avatar states ====== */
const avatarPreviewAdd = ref(null);
const uploadingAddAvatar = ref(false);
const avatarPreviewEdit = ref(null);
const uploadingEditAvatar = ref(false);

/** ====== Modal flags ====== */
const showAdd = ref(false);
const showEdit = ref(false);
const showDelete = ref(false);

/** ====== Add form ====== */
const formAdd = reactive({
  firstName: "",
  lastName: "",
  tenDangNhap: "",
  email: "",
  matKhau: "",
  confirmPassword: "",
  soDienThoai: "",
  idChucVu: null,
  idPhongBan: null,
  active: true,
  avatarUrl: null,
  // mới
  gioiTinh: null,
  tinhTrangHonNhan: null,
  ngaySinh: "",
  cccd: "",
  diaChi: "",
});
const matrixAdd = reactive({});
const savingAdd = ref(false);

/** ====== Edit form ====== */
const currentId = ref(null);
const formEdit = reactive({
  hoTen: "",
  tenDangNhap: "",
  email: "",
  soDienThoai: "",
  idChucVu: null,
  idPhongBan: null,
  active: true,
  avatarUrl: null,
  matKhau: "",
  confirmMatKhau: "",
  // mới
  gioiTinh: null,
  tinhTrangHonNhan: null,
  ngaySinh: "",
  cccd: "",
  diaChi: "",
});
const matrixEdit = reactive({});
const savingEdit = ref(false);

/** ====== Delete ====== */
const toDelete = ref(null);
const deleting = ref(false);

/** ====== Helpers ====== */
function alertErr(e, fallback = "Something went wrong") {
  const msg = e?.response?.data?.message || e?.message || fallback;
  alert(msg);
}

function validateCommon(payload) {
  if (payload.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
    throw new Error("Email không hợp lệ");
  }
  if (payload.soDienThoai && !/^[0-9+\-\s]{6,20}$/.test(payload.soDienThoai)) {
    throw new Error("Số điện thoại không hợp lệ");
  }
  if (payload.cccd && !/^\d{9,12}$/.test(payload.cccd)) {
    throw new Error("CCCD không hợp lệ (9–12 chữ số)");
  }
}

async function loadUsers(goToPage = 0) {
  try {
    page.value = goToPage;
    const { data } = await api.get("/api/nguoi-dung", {
      params: {
        keyword: keyword.value,
        phongBanId: filterPhongBanId.value,
        page: page.value,
        size: size.value,
      },
    });
    const payload = data?.data;
    users.value = payload?.content || [];
    totalPages.value = payload?.totalPages || 1;
  } catch (e) {
    alertErr(e, "Failed to load users");
  }
}

async function loadChucVu() {
  try {
    const { data } = await api.get("/api/chuc-vu", {
      params: { page: 0, size: 1000 },
    });
    chucVuOptions.value = data?.data?.content || [];
  } catch (e) {
    alertErr(e, "Failed to load roles (chuc_vu)");
  }
}

async function loadPhongBan() {
  try {
    const { data } = await api.get("/api/phong-ban", {
      params: { page: 0, size: 1000 },
    });
    phongBanOptions.value = data?.data?.content || [];
  } catch (e) {
    alertErr(e, "Failed to load departments (phong_ban)");
  }
}

async function loadActions() {
  try {
    const { data } = await api.get("/api/hanh-dong", {
      params: { page: 0, size: 1000 },
    });
    actions.value = data?.data?.content || [];
  } catch (e) {
    alertErr(e, "Failed to load actions");
  }
}

async function loadChucNang() {
  try {
    const { data } = await api.get("/api/chuc-nang", {
      params: { page: 0, size: 1000 },
    });
    chucNangList.value = data?.data?.content || [];
  } catch (e) {
    alertErr(e, "Failed to load modules (chuc_nang)");
  }
}

async function loadQuyenMask() {
  if (!actions.value.length) await loadActions();
  const nameToCode = new Map(
    actions.value.map((a) => [a.tenHanhDong, a.maHanhDong])
  );
  const { data } = await api.get("/api/quyen", {
    params: { page: 0, size: 2000 },
  });
  const list = data?.data?.content || [];
  const pairs = new Set();
  for (const q of list) {
    const code = nameToCode.get(q.hanhDong) || q.hanhDong;
    const moduleName = q.chucNang;
    pairs.add(`${moduleName}__${code}`);
  }
  allowedPairs.value = pairs;
}

function buildEmptyMatrix(target) {
  for (const key of Object.keys(target)) delete target[key];
  for (const cn of chucNangList.value) {
    target[cn.tenChucNang] = {};
    for (const act of actions.value) {
      target[cn.tenChucNang][act.maHanhDong] = false;
    }
  }
}

async function getMatrixForUser(userId) {
  const { data } = await api.get("/api/rbac-admin/matrix", {
    params: { idNguoiDung: userId },
  });
  return data?.data || {};
}

async function putMatrixForUser(userId, matrix) {
  await api.put("/api/rbac-admin/matrix", matrix, {
    params: { idNguoiDung: userId },
  });
}

/** ====== Upload avatar helpers ====== */
async function uploadImage(file) {
  const fd = new FormData();
  fd.append("files", file);
  fd.append("folderName", "user");
  const res = await api.post("/api/images/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const arr = res?.data;
  if (!Array.isArray(arr) || arr.length === 0) throw new Error("Upload failed");
  return { url: arr[0].location };
}

async function onAddAvatarSelect(e) {
  const file = e.target.files?.[0];
  if (!file) return;
  uploadingAddAvatar.value = true;
  try {
    const img = await uploadImage(file);
    formAdd.avatarUrl = img.url;
    avatarPreviewAdd.value = img.url;
  } catch (err) {
    alertErr(err, "Upload avatar failed");
  } finally {
    uploadingAddAvatar.value = false;
  }
}

async function onEditAvatarSelect(e) {
  const file = e.target.files?.[0];
  if (!file) return;
  uploadingEditAvatar.value = true;
  try {
    const img = await uploadImage(file);
    formEdit.avatarUrl = img.url;
    avatarPreviewEdit.value = img.url;
  } catch (err) {
    alertErr(err, "Upload avatar failed");
  } finally {
    uploadingEditAvatar.value = false;
  }
}

/** ====== Add modal ====== */
async function openAdd() {
  try {
    await Promise.all([
      loadChucVu(),
      loadPhongBan(),
      loadActions(),
      loadChucNang(),
    ]);
    await loadQuyenMask();
    buildEmptyMatrix(matrixAdd);
    Object.assign(formAdd, {
      firstName: "",
      lastName: "",
      tenDangNhap: "",
      email: "",
      matKhau: "",
      confirmPassword: "",
      soDienThoai: "",
      idChucVu: chucVuOptions.value[0]?.idChucVu || null,
      idPhongBan: phongBanOptions.value[0]?.idPhongBan || null,
      active: true,
      avatarUrl: null,
      // reset mới
      gioiTinh: null,
      tinhTrangHonNhan: null,
      ngaySinh: "",
      cccd: "",
      diaChi: "",
    });
    avatarPreviewAdd.value = null;
    showAdd.value = true;
  } catch (e) {
    alertErr(e, "Failed to initialize Add form");
  }
}
function closeAdd() {
  showAdd.value = false;
}

function validateAdd() {
  if (formAdd.matKhau !== formAdd.confirmPassword) {
    throw new Error("Xác nhận mật khẩu không khớp");
  }
  validateCommon({
    email: formAdd.email,
    soDienThoai: formAdd.soDienThoai,
    cccd: formAdd.cccd,
  });
}

async function submitAdd() {
  try {
    validateAdd();
    savingAdd.value = true;
    const hoTen = [formAdd.firstName, formAdd.lastName]
      .filter(Boolean)
      .join(" ")
      .trim();
    const req = {
      tenDangNhap: formAdd.tenDangNhap,
      matKhau: formAdd.matKhau,
      hoTen,
      email: formAdd.email,
      soDienThoai: formAdd.soDienThoai,
      idChucVu: formAdd.idChucVu,
      idPhongBan: formAdd.idPhongBan,
      trangThai: formAdd.active ? 1 : 0,
      avatarUrl: formAdd.avatarUrl || null,
      // mới
      gioiTinh: formAdd.gioiTinh,
      tinhTrangHonNhan: formAdd.tinhTrangHonNhan,
      ngaySinh: formAdd.ngaySinh || null,
      cccd: formAdd.cccd || null,
      diaChi: formAdd.diaChi || null,
    };
    const { data } = await api.post("/api/nguoi-dung", req);
    const newId = data?.data?.idNguoiDung;
    if (newId) {
      const anyChecked = Object.values(matrixAdd).some((row) =>
        Object.values(row).some((v) => v)
      );
      if (anyChecked) await putMatrixForUser(newId, matrixAdd);
    }
    alert("Tạo thành công");
    showAdd.value = false;
    await loadUsers(page.value);
  } catch (e) {
    alertErr(e, "Failed to create user");
  } finally {
    savingAdd.value = false;
  }
}

/** ====== Edit modal ====== */
async function openEdit(u) {
  try {
    currentId.value = u.idNguoiDung;
    await Promise.all([
      loadChucVu(),
      loadPhongBan(),
      loadActions(),
      loadChucNang(),
    ]);
    await loadQuyenMask();

    const { data } = await api.get(`/api/nguoi-dung/${currentId.value}`);
    const detail = data?.data || {};

    const mappedChucVu =
      chucVuOptions.value.find((cv) => cv.tenChucVu === detail.chucVu)
        ?.idChucVu || null;
    const mappedPhongBan =
      detail.phongBanId != null
        ? detail.phongBanId
        : phongBanOptions.value.find((pb) => pb.tenPhongBan === detail.phongBan)
            ?.idPhongBan || null;

    Object.assign(formEdit, {
      hoTen: detail.hoTen || "",
      tenDangNhap: detail.tenDangNhap || "",
      email: detail.email || "",
      soDienThoai: detail.soDienThoai || "",
      idChucVu: mappedChucVu,
      idPhongBan: mappedPhongBan,
      active: detail.trangThai === 1,
      avatarUrl: detail.avatarUrl || null,
      matKhau: "",
      confirmMatKhau: "",
      // mới
      gioiTinh: detail.gioiTinh ?? null,
      tinhTrangHonNhan: detail.tinhTrangHonNhan ?? null,
      ngaySinh: detail.ngaySinh ?? "",
      cccd: detail.cccd ?? "",
      diaChi: detail.diaChi ?? "",
    });
    avatarPreviewEdit.value = detail.avatarUrl || null;

    const matrix = await getMatrixForUser(currentId.value);
    buildEmptyMatrix(matrixEdit);
    for (const moduleName of Object.keys(matrix)) {
      if (!matrixEdit[moduleName]) matrixEdit[moduleName] = {};
      for (const act of Object.keys(matrix[moduleName])) {
        if (typeof matrixEdit[moduleName][act] !== "undefined") {
          matrixEdit[moduleName][act] = !!matrix[moduleName][act];
        }
      }
    }
    showEdit.value = true;
  } catch (e) {
    alertErr(e, "Failed to open Edit form");
  }
}
function closeEdit() {
  showEdit.value = false;
}

function validateEdit() {
  if (formEdit.matKhau || formEdit.confirmMatKhau) {
    if (formEdit.matKhau !== formEdit.confirmMatKhau) {
      throw new Error("Xác nhận mật khẩu không khớp");
    }
  }
  validateCommon({
    email: formEdit.email,
    soDienThoai: formEdit.soDienThoai,
    cccd: formEdit.cccd,
  });
}

async function submitEdit() {
  try {
    validateEdit();
    savingEdit.value = true;
    const req = {
      hoTen: formEdit.hoTen,
      tenDangNhap: formEdit.tenDangNhap, // cho phép đổi username
      email: formEdit.email,
      soDienThoai: formEdit.soDienThoai,
      idChucVu: formEdit.idChucVu,
      idPhongBan: formEdit.idPhongBan,
      trangThai: formEdit.active ? 1 : 0,
      avatarUrl: formEdit.avatarUrl || null,
      // mới
      gioiTinh: formEdit.gioiTinh,
      tinhTrangHonNhan: formEdit.tinhTrangHonNhan,
      ngaySinh: formEdit.ngaySinh || null,
      cccd: formEdit.cccd || null,
      diaChi: formEdit.diaChi || null,
      ...(formEdit.matKhau ? { matKhau: formEdit.matKhau } : {}),
    };
    await api.put(`/api/nguoi-dung/${currentId.value}`, req);
    await putMatrixForUser(currentId.value, matrixEdit);
    alert("Cập nhật thành công");
    showEdit.value = false;
    await loadUsers(page.value);
  } catch (e) {
    alertErr(e, "Failed to update user");
  } finally {
    savingEdit.value = false;
  }
}

/** ====== Delete ====== */
function confirmDelete(u) {
  toDelete.value = u;
  showDelete.value = true;
}
async function doDelete() {
  if (!toDelete.value) return;
  try {
    deleting.value = true;
    await api.delete(`/api/nguoi-dung/${toDelete.value.idNguoiDung}`);
    showDelete.value = false;
    toDelete.value = null;
    await loadUsers(page.value);
  } catch (e) {
    alertErr(e, "Failed to delete user");
  } finally {
    deleting.value = false;
  }
}

/** ====== Init ====== */
onMounted(async () => {
  await loadPhongBan();
  await loadUsers(0);
});
</script>

<style scoped>
.modal-content {
  height: 80vh;
  overflow: auto;
}
.modal.show.d-block {
  display: block;
}
.bg-inverse-success {
  background: #e7f6ee;
  color: #1fa750;
  padding: 4px 10px;
  border-radius: 12px;
}
.bg-inverse-danger {
  background: #fde8e8;
  color: #e02424;
  padding: 4px 10px;
  border-radius: 12px;
}
.bg-inverse-secondary {
  background: #f0f1f3;
  color: #6b7280;
  padding: 4px 10px;
  border-radius: 12px;
}
.table-avatar .avatar img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.table-avatar a {
  margin-left: 10px;
}
.m-t-15 {
  margin-top: 15px;
}
input[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
.avatar-lg {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #eee;
}
.mr-3 {
  margin-right: 1rem;
}
</style>
